// export.ts — CSV export of logged rounds (all local; nothing leaves the device).

import type { Round } from "./store";
import { fairwayPct, holesLabel } from "./store";

function cell(v: string | number): string {
  const s = String(v ?? "");
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}
function csv(headers: string[], rows: (string | number)[][]): string {
  return [headers, ...rows].map((r) => r.map(cell).join(",")).join("\n");
}

/** Full CSV: Date, Course, Holes, Total, Putts, Fairways, GIR, Conditions, Partners, Notes. */
export function roundsCsv(rounds: Round[]): string {
  return csv(
    ["Date", "Course", "Holes", "Total", "Putts", "Fairways", "GIR", "Conditions", "Partners", "Notes"],
    rounds.map((r) => [
      r.played_on,
      r.course,
      holesLabel(r.holes_played),
      r.total_score,
      r.putts ?? "",
      r.fairways_hit !== null && r.fairways_eligible !== null
        ? `${r.fairways_hit}/${r.fairways_eligible} (${fairwayPct(r.fairways_hit, r.fairways_eligible)})`
        : "",
      r.greens_in_reg ?? "",
      r.conditions ?? "",
      r.partners.join(" · "),
      r.notes ?? "",
    ]),
  );
}

export function buildExport(rounds: Round[]): { csv: string; filename: string } {
  const stamp = new Date().toISOString().slice(0, 10);
  return { csv: roundsCsv(rounds), filename: `round-card-${stamp}.csv` };
}
